import { PillTheme } from "@redotech/redo-model/pill-theme";
import { Flex } from "@redotech/redo-web/flex";
import { SelectDropdown } from "@redotech/redo-web/select-dropdown";
import { Text } from "@redotech/redo-web/text";
import classnames from "classnames";
import { memo } from "react";
import * as conversationTagInputColorPickerCss from "./conversation-tag-input-color-picker.module.css";

const pillThemeClass: Record<PillTheme, string> = {
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.PRIMARY]: conversationTagInputColorPickerCss.primary,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.NORMAL]: conversationTagInputColorPickerCss.normal,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.PRIMARY_LIGHT]: conversationTagInputColorPickerCss.primaryLight,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SUCCESS]: conversationTagInputColorPickerCss.success,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.DANGER]: conversationTagInputColorPickerCss.danger,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.NEUTRAL_YELLOW]: conversationTagInputColorPickerCss.neutralYellow,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.NEUTRAL_BLUE]: conversationTagInputColorPickerCss.neutralBlue,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.LIGHT_PINK]: conversationTagInputColorPickerCss.lightPink,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_RED]: conversationTagInputColorPickerCss.solidRed,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_YELLOW]: conversationTagInputColorPickerCss.solidYellow,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_GREEN]: conversationTagInputColorPickerCss.solidGreen,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_NAVY]: conversationTagInputColorPickerCss.solidNavy,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_LIGHT_BLUE]:
    conversationTagInputColorPickerCss.solidLightBlue,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_PINK]: conversationTagInputColorPickerCss.solidPink,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_ORANGE]: conversationTagInputColorPickerCss.solidOrange,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_BLACK]: conversationTagInputColorPickerCss.solidBlack,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_WHITE]: conversationTagInputColorPickerCss.solidWhite,
};

export const PillThemeNames: Record<PillTheme, string> = {
  [PillTheme.NORMAL]: "Gray",
  [PillTheme.PRIMARY_LIGHT]: "Purple",
  [PillTheme.LIGHT_PINK]: "Pink",
  [PillTheme.DANGER]: "Red",
  [PillTheme.NEUTRAL_YELLOW]: "Yellow",
  [PillTheme.SUCCESS]: "Green",
  [PillTheme.NEUTRAL_BLUE]: "Blue",
  [PillTheme.SOLID_RED]: "Solid red",
  [PillTheme.SOLID_YELLOW]: "Solid yellow",
  [PillTheme.SOLID_GREEN]: "Solid green",
  [PillTheme.SOLID_NAVY]: "Solid navy",
  [PillTheme.SOLID_LIGHT_BLUE]: "Solid blue",
  [PillTheme.SOLID_PINK]: "Solid pink",
  [PillTheme.SOLID_ORANGE]: "Solid orange",
  [PillTheme.SOLID_BLACK]: "Solid black",
  [PillTheme.PRIMARY]: "Solid purple",
  [PillTheme.SOLID_WHITE]: "Solid white",
};

export const PillColorPicker = memo(function PillColorPicker({
  value,
  setValue,
  options = Object.values(PillTheme),
}: {
  value: PillTheme | undefined;
  setValue(theme: PillTheme): void;
  options?: PillTheme[];
}) {
  const display = (option: PillTheme) => <ColorSquare theme={option} />;

  return (
    <SelectDropdown
      display={display}
      options={options}
      value={value}
      valueChange={setValue}
    >
      {(option) => <ColorSquare theme={option} />}
    </SelectDropdown>
  );
});

const ColorSquare = memo(function ColorSquare({ theme }: { theme: PillTheme }) {
  return (
    <Flex align="center" gap="xl">
      <div
        className={classnames(
          conversationTagInputColorPickerCss.colorSquare,
          pillThemeClass[theme],
        )}
      />
      <Text>{PillThemeNames[theme]}</Text>
    </Flex>
  );
});
